module.exports = __webpack_public_path__ + "static/img/platphom2.3552be19.png";